"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var _Core_1 = require("../../_Core");
var Buttons_1 = require("../../Buttons");
var BaseModal_1 = require("../../Internal/BaseModal");
var Localization_1 = require("../../Localization");
var UnsavedChangesPopup_styles_1 = require("./UnsavedChangesPopup.styles");
exports.default = (function (_a) {
    var BodyText = _a.BodyText, Visible = _a.Visible, Margin = _a.Margin, OnCloseRequest = _a.OnCloseRequest, Header = _a.Header;
    var handleKeepEditing = function () {
        OnCloseRequest("KeepEditing");
    };
    var handleSave = function () {
        OnCloseRequest("Save");
    };
    var handleDontSave = function () {
        OnCloseRequest("DontSave");
    };
    var footer = function () { return (React.createElement(UnsavedChangesPopup_styles_1.PopupFooter, null,
        React.createElement("div", null,
            React.createElement(Buttons_1.SecondaryButton, { Caption: Localization_1.strings.UnsavedChangesPopup_Action_DontSave, OnClick: function () { return handleDontSave(); } })),
        React.createElement("div", null,
            React.createElement(Buttons_1.SecondaryButton, { Caption: Localization_1.strings.UnsavedChangesPopup_Action_KeepEditing, OnClick: function () { return handleKeepEditing(); } })),
        React.createElement("div", null,
            React.createElement(Buttons_1.PrimaryButton, { Icon: _Core_1.Icons.Save, Caption: Localization_1.strings.UnsavedChangesPopup_Action_Save, OnClick: function () { return handleSave(); } })))); };
    return Visible
        ?
            React.createElement(BaseModal_1.BaseModal, { Header: Header ? Header : Localization_1.strings.UnsavedChangesPopup_Label_Header, MarginTopBottom: Margin, Height: "250px", Width: "auto", OnCloseRequest: handleKeepEditing, RenderFooter: footer },
                React.createElement(UnsavedChangesPopup_styles_1.Container, null, BodyText))
        :
            null;
});
